import type { HierarchyTree } from '@occ/contracts';

/**
 * Buscador de la sección 9 / fase 5: "por alias o nombre de sucursal/cliente
 * que centra el viewport y resalta el resultado (expandiendo lo necesario en
 * el camino)". Prioriza nodo hoja sobre sucursal sobre cliente porque el JTBD
 * real (sección 6) es encontrar la máquina exacta, no solo llegar al cliente —
 * si alguien busca "Caja1" quiere ese nodo, no que gane un cliente que
 * casualmente matchee antes en el árbol.
 */

export type TopologySearchMatch =
  | { kind: 'client'; clientId: string; label: string }
  | { kind: 'branch'; clientId: string; branchId: string; label: string }
  | { kind: 'leaf'; clientId: string; branchId: string; nodeId: string; label: string };

export function findTopologyMatch(tree: HierarchyTree, query: string): TopologySearchMatch | null {
  const q = query.trim().toLowerCase();
  if (!q) return null;

  const clientMatches: TopologySearchMatch[] = [];
  const branchMatches: TopologySearchMatch[] = [];
  const leafMatches: TopologySearchMatch[] = [];

  for (const client of tree.clients) {
    if (client.name.toLowerCase().includes(q)) {
      clientMatches.push({ kind: 'client', clientId: client.id, label: client.name });
    }
    for (const branch of client.branches) {
      if (branch.name.toLowerCase().includes(q)) {
        branchMatches.push({
          kind: 'branch',
          clientId: client.id,
          branchId: branch.id,
          label: branch.name,
        });
      }
      for (const node of branch.nodes) {
        if (node.alias.toLowerCase().includes(q)) {
          leafMatches.push({
            kind: 'leaf',
            clientId: client.id,
            branchId: branch.id,
            nodeId: node.id,
            label: node.alias,
          });
        }
      }
    }
  }

  return leafMatches[0] ?? branchMatches[0] ?? clientMatches[0] ?? null;
}
